import { GetStockTransfersQuery } from 'data/__generated__';

export const sortStockTransfers = (stockTransfers: GetStockTransfersQuery['stockTransfers']['stockTransfers']) => {
    const sortedStockTransfers = [...stockTransfers];
    // `transferDate` is a BirthdayDate (YYYY-MM-DD), so a lexicographic comparison is a chronological one.
    return sortedStockTransfers.sort((stockTransferA, stockTransferB) => {
        const isAEarlierThanB = stockTransferA.transferDate < stockTransferB.transferDate;
        const wasAUpdatedEarlierThanB =
            stockTransferA.transferDate === stockTransferB.transferDate &&
            stockTransferA.updatedAt < stockTransferB.updatedAt;

        return isAEarlierThanB || wasAUpdatedEarlierThanB ? 1 : -1;
    });
};
